import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
;(() => {
	/**
	 * ページ内リンク（`a.smoothscroll[href^="#"]`）に
	 * スムーススクロールを設定する初期化関数。
	 */
	const initSmoothScroll = () => {
		const smoothScrollLinks = document.querySelectorAll('a.smoothscroll[href^="#"]')

		smoothScrollLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				// クリックされたリンクの href（例: "#section1"）を取得
				const href = link.getAttribute('href')
				// href が空、もしくは "#" だけの場合は何もしない
				if (!href || href.length < 2) return

				// 対象となる要素を取得（例: document.querySelector("#section1")）
				const targetElement = document.querySelector(href)
				if (!targetElement) return

				// 通常のリンク遷移をキャンセルして、スムーススクロールで移動
				event.preventDefault()
				targetElement.scrollIntoView({ behavior: 'smooth' })
			})
		})
	}

	/**
	 * ページトップボタン（`.page-top-btn`）の表示・非表示を
	 * スクロール位置に応じて切り替える初期化関数。
	 */
	const initPageTopButton = () => {
		const pageTopButton = document.querySelector('.page-top-btn')
		// ボタンが存在しないページでは何もせず終了
		if (!pageTopButton) return

		// このピクセル量より下にスクロールしたらボタンを表示
		const scrollThreshold = 300

		/**
		 * 現在のスクロール量に応じて
		 * `.is-visible` クラスを付け外しする。
		 */
		const updateVisibility = () => {
			const shouldShowButton = window.scrollY > scrollThreshold
			pageTopButton.classList.toggle('is-visible', shouldShowButton)
		}

		// スクロールイベントで都度表示状態を更新
		window.addEventListener('scroll', updateVisibility, { passive: true })
		// ページのロード完了時にも一度状態を更新
		window.addEventListener('load', updateVisibility)
		// スクリプト読み込み直後も状態を反映させる
		updateVisibility()
	}

	// 即時実行関数内で各機能を初期化
	initSmoothScroll()
	initPageTopButton()
})()
;(() => {
	// Fisher-Yates で配列をその場シャッフルする。
	const shuffleInPlace = (items) => {
		for (let i = items.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1))
			;[items[i], items[j]] = [items[j], items[i]]
		}
	}

	// 各カルーセル行の前半画像を集約し、行ごとにランダム再配置して無限スクロール用に2回並べる。
	const setupCaseCarousel = () => {
		const tracks = [...document.querySelectorAll('#sec-case .carousel-track')]
		if (!tracks.length) return

		const pool = tracks.flatMap((track) => {
			const images = [...track.querySelectorAll('img')]
			const firstHalf = images.slice(0, images.length / 2)
			return firstHalf.map((img) => img.cloneNode(true))
		})

		shuffleInPlace(pool)
		const perRow = Math.ceil(pool.length / tracks.length)

		tracks.forEach((track, index) => {
			const rowImages = pool.slice(index * perRow, (index + 1) * perRow)
			track.innerHTML = ''
			rowImages.forEach((img) => track.appendChild(img.cloneNode(true)))
			rowImages.forEach((img) => track.appendChild(img.cloneNode(true)))
		})
	}

	// 固定ヘッダーの lead が #mv の上に重なった時だけ明色スタイルを付与する。
	const setupLeadColorToggle = () => {
		const lead = document.querySelector('#follow-header .lead')
		const darkSections = [...document.querySelectorAll('#mv')]
		if (!lead || !darkSections.length) return

		const updateLeadColor = () => {
			const leadRect = lead.getBoundingClientRect()
			const leadCenterY = leadRect.top + leadRect.height / 2

			const isOnDarkSection = darkSections.some((section) => {
				const rect = section.getBoundingClientRect()
				return leadCenterY >= rect.top && leadCenterY <= rect.bottom
			})

			lead.classList.toggle('is-light', isOnDarkSection)
		}

		window.addEventListener('scroll', updateLeadColor, { passive: true })
		updateLeadColor()
	}

	// Swiper 本体のロードタイミングに依存するため、見つかるまで短時間だけリトライする。
	const setupUservoiceSlider = () => {
		const slider = document.querySelector('.uservoice-slider')
		if (!slider) return

		new Swiper(slider, {
			modules: [Autoplay],
			slidesPerView: 'auto',
			spaceBetween: 16,
			centeredSlides: true,
			loop: true,
			grabCursor: true,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false
			}
		})
	}

	// ── GSAP ScrollTrigger アニメーション ──────────────────────────────────────
	const setupScrollAnimations = () => {
		// ── #mv ─────────────────────────────────────────────────────
		// キャッチコピー・ロゴをロード時にフェードイン
		const mv = document.querySelector('#mv')
		const mvBg = document.querySelector('#mv .img-bg')
		const mvMasked = document.querySelector('#mv .img-masked')
		const centerContent = document.querySelector('#mv .center-content')

		if (mv && centerContent) {
			// X 中央揃えを GSAP に委譲（CSS の translateX(-50%) を置き換え）
			gsap.set(centerContent, { xPercent: -50 })

			// ① ロード時フェードイン（スクロール演出と独立）
			const mvTextEls = [document.querySelector('#mv .catch'), document.querySelector('#mv .page-title-logo')].filter(Boolean)
			if (mvTextEls.length) {
				// CSS で opacity:0 にしているため gsap.set で初期 y をセットし gsap.to でフェードイン
				gsap.set(mvTextEls, { y: 30 })
				gsap.to(mvTextEls, {
					opacity: 1,
					y: 0,
					duration: 1.8,
					ease: 'expo.out',
					stagger: 0.45,
					delay: 0.5
				})
			}

			// ② 初期位置を記録してターゲット y 値を事前計算（ピン適用前に実行）
			const ccRect = centerContent.getBoundingClientRect()
			// center-content の中心を画面中央へ移動するオフセット
			const centerY = window.innerHeight / 2 - (ccRect.top + ccRect.height / 2)
			// ③ img-bg と img-masked を同一グループとして扱う
			const mvImages = [mvBg, mvMasked].filter(Boolean)
			// SP/PC で拡大率を切り替え
			const mvScale = window.innerWidth <= 768 ? 1.6 : 1.4

			// ④ スクロール連動ピン付きタイムライン
			const mvTl = gsap.timeline({
				scrollTrigger: {
					trigger: mv,
					start: 'top top',
					end: '+=80%',
					pin: true,
					scrub: 1,
					anticipatePin: 1
				}
			})

			// 画像は表示したままズームインし、center-content を画面中央へ移動する。
			if (mvImages.length) {
				mvTl.to(
					mvImages,
					{
						scale: mvScale,
						transformOrigin: 'center bottom',
						duration: 0.45,
						ease: 'power2.inOut'
					},
					0
				)
			}
			mvTl.to(
				centerContent,
				{
					y: centerY,
					duration: 0.45,
					ease: 'power3.inOut'
				},
				0
			)
		}

		// ── #sec-intro ──────────────────────────────────────────────
		const introTitle = document.querySelector('#sec-intro .title')
		if (introTitle) {
			gsap.from(introTitle, {
				opacity: 0,
				y: 55,
				duration: 1.3,
				ease: 'power3.out',
				scrollTrigger: { trigger: introTitle, start: 'top 78%', once: true }
			})
		}
		const introParas = document.querySelectorAll('#sec-intro .body p')
		if (introParas.length) {
			gsap.from(introParas, {
				opacity: 0,
				y: 40,
				duration: 1.1,
				ease: 'power3.out',
				stagger: 0.22,
				scrollTrigger: { trigger: introParas[0], start: 'top 80%', once: true }
			})
		}

		// ── #sec-effect ─────────────────────────────────────────────
		const effectTitle = document.querySelector('#sec-effect .title')
		if (effectTitle) {
			gsap.from(effectTitle, {
				opacity: 0,
				y: 55,
				duration: 1.3,
				ease: 'power3.out',
				scrollTrigger: { trigger: effectTitle, start: 'top 78%', once: true }
			})
		}
		const effectBody = document.querySelector('#sec-effect .body')
		if (effectBody) {
			gsap.from(effectBody, {
				opacity: 0,
				y: 35,
				duration: 1.1,
				ease: 'power3.out',
				scrollTrigger: { trigger: effectBody, start: 'top 80%', once: true }
			})
		}
		// effect-list の各アイテムを個別にトリガー
		document.querySelectorAll('#sec-effect .effect-list li').forEach((item) => {
			gsap.from(item, {
				opacity: 0,
				y: 65,
				duration: 1.1,
				ease: 'power3.out',
				scrollTrigger: { trigger: item, start: 'top 83%', once: true }
			})
			const thum = item.querySelector('.thum')
			if (thum) {
				gsap.from(thum, {
					scale: 1.06,
					duration: 1.3,
					ease: 'power2.out',
					scrollTrigger: { trigger: thum, start: 'top 83%', once: true }
				})
			}
		})

		// ── #sec-product ────────────────────────────────────────────
		const productLogoChildren = document.querySelectorAll('#sec-product .logo-set > *')
		if (productLogoChildren.length) {
			gsap.from(productLogoChildren, {
				opacity: 0,
				y: 35,
				duration: 1.3,
				ease: 'power3.out',
				stagger: 0.28,
				scrollTrigger: { trigger: productLogoChildren[0].parentElement, start: 'top 80%', once: true }
			})
		}
		const productImg = document.querySelector('#sec-product .product-img')
		if (productImg) {
			gsap.from(productImg, {
				opacity: 0,
				scale: 0.93,
				y: 35,
				duration: 1.8,
				ease: 'expo.out',
				scrollTrigger: { trigger: productImg, start: 'top 78%', once: true }
			})
		}
		;['#sec-product .lead', '#sec-product .feature-label', '#sec-product .product-name', '#sec-product .product-price', '#sec-product .shop-link', '#sec-product .product-annote'].forEach((sel) => {
			const els = document.querySelectorAll(sel)
			if (!els.length) return
			gsap.from(els, {
				opacity: 0,
				y: 28,
				duration: 1.0,
				ease: 'power3.out',
				stagger: 0.1,
				scrollTrigger: { trigger: els[0], start: 'top 83%', once: true }
			})
		})

		// ── #sec-feature ────────────────────────────────────────────
		const featureTitle = document.querySelector('#sec-feature .title')
		if (featureTitle) {
			gsap.from(featureTitle, {
				opacity: 0,
				y: 55,
				duration: 1.3,
				ease: 'power3.out',
				scrollTrigger: { trigger: featureTitle, start: 'top 78%', once: true }
			})
		}
		const featureItems = document.querySelectorAll('#sec-feature .feature-list li')
		if (featureItems.length) {
			gsap.from(featureItems, {
				opacity: 0,
				y: 45,
				duration: 1.0,
				ease: 'power3.out',
				stagger: 0.14,
				scrollTrigger: { trigger: featureItems[0], start: 'top 80%', once: true }
			})
		}
		const defItems = document.querySelectorAll('#sec-feature .defenition-list .item')
		if (defItems.length) {
			gsap.from(defItems, {
				opacity: 0,
				y: 38,
				duration: 1.1,
				ease: 'power3.out',
				stagger: 0.16,
				scrollTrigger: { trigger: defItems[0], start: 'top 82%', once: true }
			})
		}

		// ── #sec-howto ──────────────────────────────────────────────
		const howtoTitle = document.querySelector('#sec-howto .title')
		if (howtoTitle) {
			gsap.from(howtoTitle, {
				opacity: 0,
				y: 55,
				duration: 1.3,
				ease: 'power3.out',
				scrollTrigger: { trigger: howtoTitle, start: 'top 78%', once: true }
			})
		}
		const howtoSteps = document.querySelectorAll('#sec-howto .howto-flow li')
		if (howtoSteps.length) {
			gsap.from(howtoSteps, {
				opacity: 0,
				y: 55,
				scale: 0.96,
				duration: 1.1,
				ease: 'power3.out',
				stagger: 0.22,
				scrollTrigger: { trigger: howtoSteps[0], start: 'top 80%', once: true }
			})
		}
		;['#sec-howto .usecase-list .item.before li', '#sec-howto .usecase-list .item.after li'].forEach((sel) => {
			const els = document.querySelectorAll(sel)
			if (!els.length) return
			gsap.from(els, {
				opacity: 0,
				y: 50,
				duration: 1.1,
				ease: 'power3.out',
				stagger: 0.17,
				scrollTrigger: { trigger: els[0], start: 'top 82%', once: true }
			})
		})

		// ── #sec-case ───────────────────────────────────────────────
		const secCase = document.querySelector('#sec-case')
		if (secCase) {
			gsap.from(secCase, {
				opacity: 0,
				duration: 1.5,
				ease: 'power2.out',
				scrollTrigger: { trigger: secCase, start: 'top 85%', once: true }
			})
		}

		// ── #sec-safety ─────────────────────────────────────────────
		const safetyTitle = document.querySelector('#sec-safety .title')
		if (safetyTitle) {
			gsap.from(safetyTitle, {
				opacity: 0,
				y: 55,
				duration: 1.3,
				ease: 'power3.out',
				scrollTrigger: { trigger: safetyTitle, start: 'top 78%', once: true }
			})
		}
		const safetyParas = document.querySelectorAll('#sec-safety .body p')
		if (safetyParas.length) {
			gsap.from(safetyParas, {
				opacity: 0,
				y: 38,
				duration: 1.1,
				ease: 'power3.out',
				stagger: 0.22,
				scrollTrigger: { trigger: safetyParas[0], start: 'top 80%', once: true }
			})
		}
		const badgeItems = document.querySelectorAll('#sec-safety .badge-list li')
		if (badgeItems.length) {
			gsap.from(badgeItems, {
				opacity: 0,
				scale: 0.72,
				duration: 0.85,
				ease: 'back.out(1.7)',
				stagger: 0.12,
				scrollTrigger: { trigger: badgeItems[0], start: 'top 82%', once: true }
			})
		}
		const safetyBtns = document.querySelectorAll('#sec-safety .btn-list li')
		if (safetyBtns.length) {
			gsap.from(safetyBtns, {
				opacity: 0,
				y: 32,
				duration: 1.0,
				ease: 'power3.out',
				stagger: 0.18,
				scrollTrigger: { trigger: safetyBtns[0], start: 'top 82%', once: true }
			})
		}

		// ── #sec-uservoices ─────────────────────────────────────────
		const voicesTitle = document.querySelector('#sec-uservoices .title')
		if (voicesTitle) {
			gsap.from(voicesTitle, {
				opacity: 0,
				y: 55,
				duration: 1.3,
				ease: 'power3.out',
				scrollTrigger: { trigger: voicesTitle, start: 'top 78%', once: true }
			})
		}
		const voicesSlider = document.querySelector('#sec-uservoices .uservoice-slider')
		if (voicesSlider) {
			gsap.from(voicesSlider, {
				opacity: 0,
				y: 45,
				duration: 1.1,
				ease: 'power3.out',
				scrollTrigger: { trigger: voicesSlider, start: 'top 82%', once: true }
			})
		}

		// ── #sec-faq ────────────────────────────────────────────────
		const faqTitle = document.querySelector('#sec-faq .title')
		if (faqTitle) {
			gsap.from(faqTitle, {
				opacity: 0,
				y: 55,
				duration: 1.3,
				ease: 'power3.out',
				scrollTrigger: { trigger: faqTitle, start: 'top 78%', once: true }
			})
		}
		document.querySelectorAll('#sec-faq .faq-list .faq-item').forEach((item) => {
			gsap.from(item, {
				opacity: 0,
				y: 28,
				duration: 0.9,
				ease: 'power3.out',
				scrollTrigger: { trigger: item, start: 'top 85%', once: true }
			})
		})
		const faqBtn = document.querySelector('#sec-faq .btn-area')
		if (faqBtn) {
			gsap.from(faqBtn, {
				opacity: 0,
				y: 32,
				duration: 1.0,
				ease: 'power3.out',
				scrollTrigger: { trigger: faqBtn, start: 'top 85%', once: true }
			})
		}
	}

	setupCaseCarousel()
	setupLeadColorToggle()
	setupUservoiceSlider()
	setupScrollAnimations()
})()

const trackFaqOpen = (title) => {
	if (document.body?.id !== 'page-faq' && !title.closest('#page-faq')) return

	const question = title.textContent?.trim() || ''
	const category = title.closest('.faq-category')?.querySelector('.faq-category-title')?.textContent?.trim() || ''

	if (typeof window.gtag === 'function') {
		window.gtag('event', 'faq_open', {
			faq_question: question,
			faq_category: category
		})
		return
	}

	if (Array.isArray(window.dataLayer)) {
		window.dataLayer.push({
			event: 'faq_open',
			faq_question: question,
			faq_category: category
		})
	}
}

const setupFaqAccordion = () => {
	document.querySelectorAll('.faq-list .faq-title').forEach((title) => {
		title.style.cursor = 'pointer'
		title.addEventListener('click', () => {
			const answer = title.nextElementSibling
			if (!(answer instanceof HTMLElement)) return

			if (title.classList.contains('open')) {
				// 閉じる: 実際の高さを起点にして0へアニメーション
				answer.style.maxHeight = `${answer.scrollHeight}px`
				requestAnimationFrame(() => {
					answer.style.maxHeight = '0'
				})
				title.classList.remove('open')
				return
			}

			// 開く: 実際の高さまでアニメーション
			title.classList.add('open')
			trackFaqOpen(title)
			answer.style.maxHeight = `${answer.scrollHeight}px`
			answer.addEventListener(
				'transitionend',
				() => {
					if (title.classList.contains('open')) {
						answer.style.maxHeight = 'none'
					}
				},
				{ once: true }
			)
		})
	})
}

setupFaqAccordion()
